import { render, staticRenderFns } from "./GridPrincipal.vue?vue&type=template&id=6a5f2103"
import script from "./GridPrincipal.vue?vue&type=script&lang=js"
export * from "./GridPrincipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports